class AdTrackingService {
  static getStorageKey(userId, canvasId) {
    return `ad_views_${userId || 'default'}_${canvasId || 'default'}`;
  }

  static getAdViews(userId, canvasId) {
    try {
      const key = this.getStorageKey(userId, canvasId);
      const viewsData = localStorage.getItem(key);
      
      if (viewsData) {
        try {
          return JSON.parse(viewsData);
        } catch (error) {
          console.error('Error parsing ad views data:', error);
          // Clear corrupted data
          try {
            localStorage.removeItem(key);
          } catch (e) {
            console.error('Error removing corrupted ad views:', e);
          }
        }
      }
      
      return {
        count: 0,
        lastReset: new Date().toISOString(),
        lastView: null,
        canvasId
      };
    } catch (error) {
      console.error('Error accessing ad views:', error);
      return {
        count: 0,
        lastReset: new Date().toISOString(),
        lastView: null,
        canvasId
      };
    }
  }

  static saveAdViews(userId, canvasId, data) {
    try {
      const key = this.getStorageKey(userId, canvasId);
      localStorage.setItem(key, JSON.stringify({...data, canvasId}));
    } catch (error) {
      console.error('Error saving ad views data:', error);
    }
  }

  static incrementAdView(userId, canvasId) {
    const data = this.getAdViews(userId, canvasId);
    data.count++;
    data.lastView = new Date().toISOString();
    this.saveAdViews(userId, canvasId, data);
    return data;
  }

  static resetAdViews(userId, canvasId) {
    const data = {
      count: 0,
      lastReset: new Date().toISOString(),
      lastView: null,
      canvasId
    };
    this.saveAdViews(userId, canvasId, data);
    return data;
  }

  static getLastAdStatus(userId, canvasId) {
    try {
      const key = `ad_status_${userId || 'default'}_${canvasId || 'default'}`;
      const statusData = localStorage.getItem(key);
      
      if (statusData) {
        try {
          const parsed = JSON.parse(statusData);
          // validation of expiry time
          if (parsed.expiresAt) {
            const now = new Date().getTime();
            const expiry = new Date(parsed.expiresAt).getTime();
            
            // If access has expired, clear the status
            if (now > expiry && parsed.hasAccess) {
              parsed.hasAccess = false;
              parsed.remainingMinutes = 0;
              this.saveAdStatus(userId, canvasId, parsed);
            }
          }
          return parsed;
        } catch (error) {
          console.error('Error parsing ad status data:', error);
          // Clear corrupted data
          try {
            localStorage.removeItem(key);
          } catch (e) {
            console.error('Error removing corrupted ad status:', e);
          }
        }
      }
      
      return null;
    } catch (error) {
      console.error('Error accessing ad status:', error);
      return null;
    }
  }

  static saveAdStatus(userId, canvasId, status) {
    try {
      const key = `ad_status_${userId || 'default'}_${canvasId || 'default'}`;
      localStorage.setItem(key, JSON.stringify({
        ...status,
        lastChecked: new Date().toISOString()
      }));
    } catch (error) {
      console.error('Error saving ad status:', error);
    }
  }
  
  //calculate remaining time in minutes
  static calculateRemainingMinutes(expiresAt) {
    if (!expiresAt) return 0;
    
    const now = new Date().getTime();
    const expiry = new Date(expiresAt).getTime();
    const diffMs = expiry - now;
    
    if (diffMs <= 0) return 0;
    
    return Math.ceil(diffMs / (1000 * 60));
  }
}

export default AdTrackingService;